import React from "react";
import { Input } from "reactstrap";

/**
 * FDateInput — date picker that always displays dd/mm/yyyy regardless of browser locale.
 *
 * Props are compatible with Reactstrap <Input type="date">:
 *   value      — YYYY-MM-DD string
 *   onChange   — receives the native input event; e.target.value is YYYY-MM-DD
 *   id, name, disabled, min, max, style — forwarded as expected
 */
function FDateInput({ value, onChange, id, name, disabled, min, max, style }) {
  const display = value ? value.split("-").reverse().join("/") : "";

  return (
    <div style={{ position: "relative", height: "40px", ...style }}>
      <Input
        type="text"
        id={id}
        readOnly
        tabIndex={-1}
        value={display}
        placeholder="dd/mm/aaaa"
        disabled={disabled}
        style={{ height: "40px", paddingRight: "36px", cursor: disabled ? "not-allowed" : "pointer", pointerEvents: "none" }}
      />
      <i
        className="tim-icons icon-calendar-60"
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          pointerEvents: "none",
          zIndex: 2,
          opacity: disabled ? 0.3 : 0.6,
          fontSize: "0.9rem",
        }}
      />
      <input
        type="date"
        name={name}
        value={value || ""}
        onChange={onChange}
        disabled={disabled}
        min={min}
        max={max}
        style={{
          position: "absolute",
          inset: 0,
          opacity: 0,
          cursor: "pointer",
          zIndex: 1,
          width: "100%",
          height: "100%",
          boxSizing: "border-box",
        }}
      />
    </div>
  );
}

export default FDateInput;
